import Controller, { type ControllerQueryParam } from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import type { ApplicationModel } from 'login/routes/application';

export default class ApplicationController extends Controller<ApplicationModel> {
  // queryParam: lec = LoginErrorCode
  override queryParams: readonly ControllerQueryParam[] = ['lec'];
  @tracked lec: string | null = null;
}
